export const snapResult = { x: 0, y: 0 };
